import { defaultIconProps, IconSvgWrapper, type IconProps } from "./base";

const CheckMarkCircleFilledIcon = (props: IconProps) => {
  props = { ...defaultIconProps, ...props };

  return (
    <IconSvgWrapper {...props} viewBox="0 0 16 16">
      <circle cx="8" cy="8" r="7.184" fill="var(--green-500)" />
      <path
        d="M4.93601 8.60041L6.67201 10.3364C6.84801 10.5124 7.14401 10.5124 7.34401 10.3364L11.232 6.44841C11.416 6.26441 11.416 5.96841 11.232 5.78441C11.048 5.60041 10.752 5.60041 10.568 5.78441L7.11201 9.24041C7.05601 9.29641 6.96001 9.29641 6.90401 9.24041L5.60001 7.93641C5.41601 7.75241 5.12001 7.75241 4.93601 7.93641C4.75201 8.12041 4.75201 8.41641 4.93601 8.60041Z"
        fill="#FFFFFF"
      />
    </IconSvgWrapper>
  );
};

export default CheckMarkCircleFilledIcon;
